import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const NativeMobileAppsTextBlock = (): JSX.Element => {
  return (
    <Stack
      justify='center'
      align='center'
      maxWidth='width-xl'
      margin={['spacing-none', 'spacing-auto']}
    >
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: 'lg',
          text: 'Native Mobile Apps',
          fontWeight: 'font-weight-semibold',
          textAlign: 'center',
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          color: 'text-tertiary',
          textAlign: 'center',
          text: "Real iOS and Android apps on your members' home screens. Not web wrappers. On Mighty, 60% more activity happens on mobile than web. Your community becomes part of the daily life of your members.",
        }}
        subHeading={{
          type: 'paragraph',
          size: 'md',
          fontWeight: 'font-weight-semibold',
          color: 'text-brand-secondary',
          textAlign: 'center',
          text: "It's the Phones",
        }}
        gap='spacing-3xl'
        subHeadingGap='spacing-lg'
      />
    </Stack>
  );
};

export default NativeMobileAppsTextBlock;
